import EditorCoreState from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state: EditorCoreState = {
  dropState: {
    position: undefined,
    isVisible: false
  },
  focus: {
    currentFocusId: '',
    nextFocusId: ''
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
